/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { iconButtonLegalbirdStyle } from "./iconButtonLegalbirdStyle.ts";
import VisuallyHidden from "@/src/components/VisuallyHidden/VisuallyHidden.tsx";

export type IconButtonLegalbirdProps = {
  variant?: "contained" | "text";
  label: string;
} & MuiIconButtonProps;

export default function IconButtonLegalbird({ label, children, variant = "contained", sx, ...muiButtonProps }: IconButtonLegalbirdProps) {
  return (
    <MuiIconButton {...muiButtonProps} sx={mergeSx(variant === "contained" && iconButtonLegalbirdStyle.contained, sx)}>
      {children}
      <VisuallyHidden>{label}</VisuallyHidden>
    </MuiIconButton>
  );
};
